import { EnvironmentProviders } from '@angular/core';
import { provideState } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { MODULE_FEATURE_KEY } from './keys';
import { moduleReducer } from './reducers/module.reducer';
import { ModuleEffects } from './effects/module.effects';

export function provideModuleStore(): EnvironmentProviders[] {
    return [provideState(MODULE_FEATURE_KEY, moduleReducer), provideEffects(ModuleEffects)];
}
